import { ScrollArea as MantineScrollArea } from "@mantine/core";

export const ScrollArea = MantineScrollArea;
